import { render, staticRenderFns } from "./AccountingRuleGroup.vue?vue&type=template&id=0a013827&"
import script from "./AccountingRuleGroup.vue?vue&type=script&lang=js&"
export * from "./AccountingRuleGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports